import { useState, useEffect } from 'react'
import { ProposalsProps } from '../../../lib/types';

type ProposalsData = {
    recordingServerSpecificationTableBody: string[],
    netWorkInterfaceTableBody: string[][],
    liveDatabaseStorageTableBody: string[][],
    hasArchiving: boolean,
    archivingDatabaseStorageTableBody: string[][]
}

export const useProposalGenericData = (proposals: ProposalsProps): ProposalsData => {

    const [proposalCalculationData, setProposalCalculationData] = useState(proposals?.calculationData?.data);
    const [proposalSiteDesignData, setProposalSiteDesignData] = useState(proposals?.siteDesignData);
    useEffect(() => {
        if (proposals) {
            setProposalCalculationData(proposals.calculationData?.data);
            setProposalSiteDesignData(proposals.siteDesignData);
        }
    }, [proposals]);
       
    const recordingServerSpecificationTableBody = [
        proposalCalculationData?.genericProposal?.quantity,
        proposalCalculationData?.genericProposal?.machineType,
        proposalCalculationData?.genericProposal?.cpuType,
        proposalCalculationData?.genericProposal?.osDisk,
        proposalCalculationData?.genericProposal?.ram
    ];

    const netWorkInterfaceTableBody = proposalCalculationData?.networkInterface?.map(obj => Object.values(obj));

    const liveDatabaseStorageTableBody: string[][] = [
        [
            proposalCalculationData?.liveDatabase?.quantity?.toString(),
            proposalCalculationData?.liveDatabase?.diskType,
            proposalCalculationData?.liveDatabase?.diskSize
        ],
        [
            proposalCalculationData?.liveDatabase?.raidType,
            proposalCalculationData?.liveDatabase?.reqCapacity,
            proposalCalculationData?.liveDatabase?.formattedCapacity
        ],
        [
            proposalCalculationData?.liveDatabase?.connectivity,
            proposalCalculationData?.liveDatabase?.iops,
            proposalCalculationData?.liveDatabase?.transferSpeed
        ]
    ];

    const hasArchiving = proposalSiteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiving;
    const archivingDatabaseStorageTableBody: string[][] = [
        [
            proposalCalculationData?.archiveDatabase?.quantity,
            proposalCalculationData?.archiveDatabase?.diskType,
            proposalCalculationData?.archiveDatabase?.diskSize
        ],
        [
            proposalCalculationData?.archiveDatabase?.raidType,
            proposalCalculationData?.archiveDatabase?.reqCapacity,
            proposalCalculationData?.archiveDatabase?.formattedCapacity
        ],
        [
            proposalCalculationData?.archiveDatabase?.connectivity,
            proposalCalculationData?.archiveDatabase?.iops,
            proposalCalculationData?.archiveDatabase?.transferSpeed
        ]
    ];

    

    return {
        recordingServerSpecificationTableBody,
        netWorkInterfaceTableBody,
        liveDatabaseStorageTableBody,
        hasArchiving,
        archivingDatabaseStorageTableBody
    }
}